import type { FuelTransactionBodyContent } from '@cobliteam/common-types';
import type { SaveFuelTransactionAPI, ZendeskTicketAPI } from './Definitions/APITypes';
import type { ZendeskTicket } from './Definitions/Types';

export const toSaveFuelTransactionBody = (body: FuelTransactionBodyContent): SaveFuelTransactionAPI => ({
  transaction_time: body.transactionTime,
  vehicle_id: body.vehicleId,
  ...(body.odometerInKm === undefined ? {} : { odometer_in_km: body.odometerInKm }),
  driver_name: body.driverName,
  fuel_type: body.fuelType,
  total_cost: body.totalCost,
  quantity_in_liters: body.quantityInLiters,
  merchant: body.merchant,
  ...(body.fileBase64 && body.fileContentType ? { file_base64: body.fileBase64, file_content_type: body.fileContentType } : {}),
  ...(body.odometerFileBase64 && body.odometerFileContentType ? { odometer_file_base64: body.odometerFileBase64, odometer_file_content_type: body.odometerFileContentType } : {}),
});

export const openNewFuelCardTicketToOpenNewFuelCardTicketAPI = (zendeskTicket: ZendeskTicket): ZendeskTicketAPI => ({
  problem: zendeskTicket.problem,
  message: zendeskTicket.message,
  fleet_name: zendeskTicket.fleetName,
  fleet_id: zendeskTicket.fleetId,
  user_name: zendeskTicket.userName,
  user_email: zendeskTicket.userEmail,
});
